import NoticeBar from "./components/NoticeBar";
import SiteNavbar from "./components/SiteNavbar";
import HeroSection from "./components/HeroSection";
import TopicSection from "./components/TopicSection";
import CollectionSection from "./components/CollectionSection";
import ArchiveSection from "./components/ArchiveSection";
import RankSection from "./components/RankSection";
import DiscussionSection from "./components/DiscussionSection";
import SubscribeSection from "./components/SubscribeSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <NoticeBar />
      <SiteNavbar />
      <main className="flex-1">
        <HeroSection />
        <TopicSection />
        <CollectionSection />
        <ArchiveSection />
        <RankSection />
        <DiscussionSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
    </div>
  );
}